<template>
  <div class="offer-types-list">
    <el-checkbox-group
      :value="localValue"
      @input="val => (localValue = val)"
      :disabled="field.isDisabled"
      :size="field.componentProps ? field.componentProps.size : 'mini'"
    >
      <el-checkbox
        v-for="option in filteredOptions"
        :key="option.value"
        :label="option.value"
        class="offer-option"
      >
        {{ option.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: 'GenericFieldOfferTypes',
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    },
    searchValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    localValue: {
      get() {
        return Array.isArray(this.value) ? this.value : []
      },
      set(val) {
        const normalized = Array.isArray(val) ? val : []
        this.$emit('input', normalized)
        this.$emit('change', { field: this.field.name, value: normalized })
      }
    },
    
    //  Gérer les sources de type 'store' ET les données statiques
    options() {
      if (!this.field || !this.field.dataSource) {
        return []
      }
      
      //  Si la source est de type 'store', récupérer depuis le Vuex store
      if (this.field.dataSource.type === 'store') {
        const storeData = this.getStoreData()
        return this.formatStoreData(storeData)
      }
      
      //  Sinon, utiliser les données statiques (venant de /config)
      if (this.field.dataSource.data && Array.isArray(this.field.dataSource.data)) {
        return this.field.dataSource.data.map(item => ({
          value: item.code || item.value,
          label: item.libelle || item.label || item.name
        }))
      }
      
      return []
    },
    
    filteredOptions() {
      if (!this.searchValue || this.searchValue.trim() === '') {
        return this.options
      }
      
      const search = this.searchValue.toLowerCase()
      return this.options.filter(option => 
        option.label.toLowerCase().includes(search)
      )
    }
  },
  
  methods: {
    //  Méthodes pour gérer les sources de type 'store'
    getStoreData() {
      // Les paramètres sont dans field.dataSource.parameters (venant du backend)
      const parameters = this.field.dataSource.parameters || {}
      const storePath = parameters.storePath || this.field.dataSource.storePath
      const storeGetter = parameters.storeGetter || this.field.dataSource.storeGetter
      const storeAction = parameters.storeAction || this.field.dataSource.storeAction
      
      
      //  Déclencher l'action pour charger les données si nécessaire
      if (storeAction && this.$store._actions[storeAction]) {
        this.$store.dispatch(storeAction).catch(error => {
          console.warn(` [SearchFieldOfferTypes] Erreur lors du dispatch de ${storeAction}:`, error)
        })
      }
      
      // Utiliser le getter si disponible
      if (storeGetter && this.$store.getters[storeGetter]) {
        const data = this.$store.getters[storeGetter]
        return data
      }
      
      // Ou accéder directement au state avec un chemin
      if (storePath) {
        const parts = storePath.split('.')
        let data = this.$store.state
        for (const part of parts) {
          data = data && data[part]
        }
        return data
      }
      
      console.warn(` [SearchFieldOfferTypes.getStoreData] Aucune source trouvée pour ${this.field.name}`)
      return []
    },
    
    formatStoreData(storeData) {
      if (!Array.isArray(storeData)) {
        console.warn(` [SearchFieldOfferTypes.formatStoreData] Les données du store ne sont pas un tableau:`, storeData)
        return []
      }
      
      const parameters = this.field.dataSource.parameters || {}
      const valueField = parameters.valueField || 'value' || 'code'
      const labelField = parameters.labelField || 'label' || 'libelle'
      
      return storeData.map(item => {
        const rawLabel = item[labelField] || item.libelle || item.label || item.name || `Option ${item[valueField] || item.code || item.value}`
        return {
          value: item[valueField] || item.code || item.value,
          label: this.capitalizeFirstLetter(rawLabel)
        }
      })
    },
    
    //  Fonction utilitaire pour capitaliser la première lettre
    capitalizeFirstLetter(str) {
      if (!str || typeof str !== 'string') return str
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }
  }
}
</script>

<style scoped>
.offer-types-list {
  width: 100%;
}

.offer-option {
  display: block !important;
  margin: 0 0 6px 0 !important;
}
</style>
